import React, { useState } from "react";

import hod from "../Assets/Faculty/hod.png";
import Princpal from "../Assets/Faculty/Pricipal.png";

import EEE from "../Assets/Faculty/EEE.png";
import ECE from "../Assets/Faculty/ECE.png";
import MECH from "../Assets/Faculty/MECH.png";
import AIML from "../Assets/Faculty/AIML.png";
import CSE from "../Assets/Faculty/CSE.png";
import CLOUD from "../Assets/Faculty/Cloud.png";
import CIVIL from "../Assets/Faculty/Civil.png";


const facultyData = [
  { id: 1, name: "Sri S V Ramana", title: "SECRETARY AND CORRESPONDENT", image: hod },
  { id: 2, name: "Sri J Siva Kumar", title: "PRINCIPAL", image: Princpal },
  { id: 3, name: "A Anil Prasad", title: " HOD AI & ML ", image: AIML },
  { id: 8, name: "D Rajesh", title: " HOD CCB ", image: CLOUD },
  { id: 4, name: "P G N V Subrahmanyam", title: " HOD CME ", image: CSE },
  { id: 9, name: "B Sowjanya", title: " HOD CIV ", image: CIVIL },
  { id: 5, name: "G L Pratap", title: " HOD ECE ", image: ECE },
  { id: 6, name: "V Nageswara Rao", title: " HOD EEE ", image: EEE },
  { id: 7, name: "P Siddi Raju", title: " HOD MEC", image: MECH },

 

 
  
];

const MeetFaculty = () => {
  const [showAll, setShowAll] = useState(false); // State to manage visibility

  // Separate Correspondent and Principal for top display
  const topFaculty = facultyData.filter(
    (faculty) => faculty.title === "SECRETARY AND CORRESPONDENT"  || faculty.title === "PRINCIPAL"
  );
  const otherFaculty = facultyData.filter(
    (faculty) => faculty.title !== "SECRETARY AND CORRESPONDENT" && faculty.title !== "PRINCIPAL"
  );

  // Split the other faculty members into groups of 5
  const groupedFaculty = [];
  for (let i = 0; i < otherFaculty.length; i += 7) {
    groupedFaculty.push(otherFaculty.slice(i, i + 7));
  }

  return (
    <div className="faculty-container p-[50px_20px] bg-[#f9f9f9] text-center">
      <h2 className="section-title text-[28px] font-bold text-[#333] mb-[4px]">
        <span style={{ color: "#89CFF0" }}>MEET</span> OUR FACULTY{" "}
      </h2>
      <hr
        className="section-divider"
        style={{
          border: "1px solid #D3D3D3",
          marginLeft: "43%",
          marginRight: "43%",
        }}
      />

      <div className="faculty-grid grid grid-cols-[repeat(auto-fit,_minmax(200px,_1fr))] gap-5 justify-center top-faculty">
        {topFaculty.map((faculty) => (
          <div key={faculty.id} className="faculty-card relative w-full h-[250px] overflow-hidden rounded-lg flex items-center m-5 p-[10%] before:absolute before:w-full before:h-full before:content-[''] before:clip-[polygon(5%_1%,_115%_0%,_95%_100%,_1%_100%)] sm:justify-center">
            <div
              className="col-12 col-md-4 d-flex justify-content-center align-items-center"
              style={{
                transform: "rotate(11deg)",
                backgroundColor: "#89CFF0",
                height: "185px",
                marginTop: "-30px",
                marginLeft: "20px",
              }}
            >
              <div style={{ color: "#89CFF0" }}>1</div>
            </div>
            <div className="faculty-details">
              <img
                src={faculty.image}
                alt={faculty.name}
                className="faculty-image w-full h-auto object-cover shadow-md"
              />
              <div className="faculty-info">
              <h4 className="text-sm  mt-1 text-[#FFA500]">{faculty.title}</h4>
                <h2 className="text-md font-bold text-black m-0">{faculty.name}</h2>
              </div>
            </div>
            <div
              className="col-12 col-md-4 d-flex justify-content-center align-items-center"
              style={{
                transform: "rotate(-168deg)",
                backgroundColor: "#89CFF0",
                height: "185px",
                marginBottom: "65px",
                marginRight: "-5px",
              }}
            >
              <div className="" style={{ color: "#89CFF0" }}>
                3
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Display other faculty members in columns of 5 */}
      {groupedFaculty.slice(0, showAll ? groupedFaculty.length : 1).map(
        (group, index) => (
          <div key={index} className="faculty-grid grid grid-cols-[repeat(auto-fit,_minmax(250px,_1fr))] gap-5  other-faculty">
            {group.map((faculty) => (
              <div key={faculty.id} className="faculty-card relative w-full h-[250px] overflow-hidden rounded-lg flex items-center m-5 p-[10%] before:absolute 
              before:w-full before:h-full before:content-[''] before:clip-[polygon(5%_1%,_115%_0%,_95%_100%,_1%_100%)] sm:justify-center">
                <div
                  className="col-12 col-md-4 d-flex justify-content-center align-items-center"
                  style={{
                    transform: "rotate(11deg)",
                    backgroundColor: "#89CFF0",
                    height: "185px",
                    marginTop: "-30px",
                    marginLeft: "20px",
                  }}
                >
                  <div style={{ color: "#89CFF0" }}>1</div>
                </div>
                <div className="faculty-details">
                  <img
                    src={faculty.image}
                    alt={faculty.name}
                    className="faculty-image w-full h-auto object-cover shadow-md"
                  />
                  <div className="faculty-info">
                  <h4 className="text-sm mt-1 text-[#FFA500] ">{faculty.title}</h4>
                  <h2 className="text-md  font-bold text-black m-0">{faculty.name}</h2>
                  </div>
                </div>
                <div
                  className="col-12 col-md-4 d-flex justify-content-center align-items-center"
                  style={{
                    transform: "rotate(-168deg)",
                    backgroundColor: "#89CFF0",
                    height: "185px",
                    marginBottom: "65px",
                    marginRight: "-5px",
                  }}
                >
                  <div className="" style={{ color: "#89CFF0" }}>
                    3
                  </div>
                </div>
              </div>
            ))}
          </div>
        )
      )}

     
      {/* <button
        className="see-more-btn px-5 py-2.5 bg-[#89CFF0] text-white border-none rounded-md mt-5 cursor-pointer hover:bg-[#77b7d4]"
        onClick={() => setShowAll(!showAll)} >
        {showAll ? "Hide" : "See More"} 
      </button> */}
    </div>
  );
};

export default MeetFaculty;
